module.exports = "./assets/assets/单一来源.eebea62b.docx";